import { RestrictionContext } from '@src/context/RestrictionContext'
import { useContext, useEffect } from 'react'
import { useGeolocated } from 'react-geolocated'

const useGeoFence = (): boolean => {
  const { restricted, setCoords } = useContext(RestrictionContext)
  const { coords } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: false,
    },
    userDecisionTimeout: 5000,
  })

  useEffect(() => setCoords(coords), [coords, setCoords])
  return restricted
}
export default useGeoFence
